<!--
 * @Author: suhe@hikvison.com.cn
 * @Date: 2019-11-14 09:10:39
 * @LastEditors: xuqing6@hikvison.com.cn
 * @LastEditTime: 2021-03-24 11:11:45
 -->
<template>
<div class="saasl-home">
  <HomeHeader />
  <div class="saasl-home-content backgroud-f2">
    <div class="forgetpassword-return">
      <el-button icon="el-icon-arrow-left" class="forgetpassword-return-btn" @click="exit">返回登录</el-button>
    </div>
    <div class="forgetpassword-wrap">
      <div class="container" :style="{margin: '0'}">
        <h2 class="container-title">找回密码</h2>
        <!-- <a href="javascript: void(0)" class="exit" @click="exit">
          <i class="iconfont icon-guanbi"></i>
        </a> -->
        <div class="content">
          <ul class="slider-ul__top">
            <li class="slider-li">验证手机号</li>
            <li class="slider-li">填写验证码</li>
            <li class="slider-li" v-if="!finishPassword">重置密码</li>
            <li class="slider-li" v-else>完成</li>
          </ul>
          <el-slider :max="maxStep" :step="50" v-model="sliderStep" :show-tooltip="false" disabled></el-slider>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
  <HomeFooter />
</div>
</template>
<script>
import logo from "../../assets/image/logo.png";
import footerIcon from "../../assets/image/footer.png";
import HomeHeader from '@/components/header';
import HomeFooter from '@/components/HomeFooter';
export default {
  components: {
    HomeFooter,
    HomeHeader
  },
  data() {
    return {
      logo,
      footerIcon,
      maxStep: 100,
      sliderStep: 0,
      finishPassword: false,
      customConfig: sessionStorage.getItem("customConfig") ? JSON.parse(sessionStorage.getItem("customConfig")) : {}
    };
  },
  mounted() {
    this.renderSlider();
  },
  methods: {
    renderSlider() {
      const id = this.$route.path.match(/\d+$/)[0] >> 0;
      this.sliderStep = (id - 1) * 50 > 100 ? 100 : (id - 1) * 50;
      if (parseInt(id, 10) === 4) {
        this.finishPassword = true;
      } else {
        this.finishPassword = false;
      }
    },
    exit() {
      history.go(-1);
    }
  },
  watch: {
    $route: function() {
      this.renderSlider();
    }
  }
};
</script>
<style lang="less" scoped>
.saasl-home-content {
  position: relative;
  display: flex;
  flex-direction: column;
  .forgetpassword-return {
    width: 800px;
    position: relative;
    top: 30px;
    .forgetpassword-return-btn {
      background: #658FFF;
      box-shadow: 0 1px 20px 0 rgba(69,143,255,0.30);
      border-radius: 4px;
      border-radius: 4px;
      width: 120px;
      height: 40px;
      color: #fff;
    }
  }
}
.forgetpassword-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .container {
    margin: 0 auto;
    position: relative;
    width: 800px;
    height: 560px;
    background: #fff;
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.1);
    .exit {
      position: absolute;
      right: 20px;
      top: 10px;
      color: #000;
      font-size: 24px;
      text-decoration: none;
      display: block;
      width: 20px;
      height: 20px;
      &:hover {
        color: #659ce2;
      }
    }
    .container-title {
      text-align: center;
      margin-top: 50px;
      margin-bottom: 50px;
      font-size: 20px;
      color: #666;
    }
    .content {
      width: 520px;
      margin: 0 auto;
      .slider-ul__top {
        display: flex;
        .slider-li {
          flex: 1;
          color: #333333;
          font-size: 14px;
          &:first-child {
            text-align: left;
            margin-left: -30px;
          }
          &:nth-child(2) {
            text-align: center;
          }
          &:last-child {
            text-align: right;
            margin-right: -30px;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.backgroud-f2 {
  background: #f2f2f2;
}
.forgetpassword-wrap {
  .el-slider__runway,
  .el-slider__bar {
    height: 10px;
    border-radius: 5px;
  }
  .el-slider__bar {
    min-width: 18px;
    box-shadow: 0px 0px 12px rgba(82, 119, 254, 0.4);
    background: linear-gradient(to bottom, #6c9cff, #5c7bfe);
  }
  .el-slider__button-wrapper {
    display: none;
    // top: 50%;
    // margin-top: -18px;
  }
  // .el-slider__button {
  //   width: 20px;
  //   height: 20px;
  // }
}
.step-container {
  color: #000;
  .step-btn {
    font-size: 14px;
    display: block;
    width: 100%;
    height: 46px;
    margin: 0;
    &.cancel-btn {
      margin: 0;
      margin-top: 20px;
      background: #ffffff;
      border: 1px solid #e6e6e6;
      color: #999999;
    }
  }
  .el-input {
    width: 100%;
  }
  
}
.saasl-home-footer__tips {
    // background: #F5F5F5;
  // position: fixed;
  // bottom: 0;
  // height: 124px;
  // width: 100%;
  // padding-top: 24px;
  span {
    vertical-align: top;
    line-height: 20px;
    font-size: 14px;
    color: #333333;
  }
  a:hover {
    color: #0056b3;
  }
}
</style>
